module.exports = __webpack_public_path__ + "img/intro1.c43e937e.png";